import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService, ConfirmationService } from 'primeng/api';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { protectedResourceInterceptor } from './core/interceptors/protected-resource.interceptor';
import { appTheme } from '../styles/theme';
import { routes } from './app.routes';
import { ChunkLoadErrorHandler } from './core/handlers/chunk-load-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: appTheme,
    }),
    provideHttpClient(
      withInterceptors([authInterceptor, protectedResourceInterceptor, errorInterceptor]),
    ),
    provideOAuthClient(),
    {
      provide: OAuthStorage,
      useFactory: () => localStorage,
    },
    MessageService,
    ConfirmationService,
    // Recover from stale lazy-chunk failures after a deploy by forcing a one-time reload.
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
  ],
};
